<template>

	<div class="row">

		<div class="col-md-7">

			<h1>
				<span v-translate>Lista de medicações para</span>
				<strong>{{ date | date("DD/MM/YYYY") }}</strong>
			</h1>

		</div>

		<div class="col-md-5">

			<ul class="list-unstyled list-inline text-right">

				<li class="text-center">
					<i class="fa fa-exclamation-triangle font-red" aria-hidden="true"></i>
					<small class="font-grey-cascade" v-translate>Medicação atrasada</small>
				</li>

				<li class="text-center">
					<i class="fa fa-check font-green" aria-hidden="true"></i>
					<small class="font-grey-cascade" v-translate>Medicação ministrada</small>
				</li>

				<li class="text-center">
					<i class="fa fa-ban font-red" aria-hidden="true"></i>
					<small class="font-grey-cascade" v-translate>Medicação rejeitada</small>
				</li>

			</ul>

			</div>

	</div>

</template>

<script>

	import MedicineLabels from './';
	export default MedicineLabels;

</script>

<style>

	.list-unstyled {
		margin-top: 39px;
	}

</style>



// WEBPACK FOOTER //
// medicine-labels.vue?a7b86c84